import { render, staticRenderFns } from "./tenant-info.vue?vue&type=template&id=afc838ac&"
import script from "./tenant-info.vue?vue&type=script&lang=js&"
export * from "./tenant-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenant-info.vue"
export default component.exports